import { render, staticRenderFns } from "./Navbar2Content.vue?vue&type=template&id=33adf7b0&scoped=true"
import script from "./Navbar2Content.vue?vue&type=script&lang=js"
export * from "./Navbar2Content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33adf7b0",
  null
  
)

export default component.exports